import React from 'react';
import { RevealOnScroll } from '../ui/RevealOnScroll';
export function Manifesto() {
  return <section className="bg-ink py-[100px] md:py-[200px] px-6 flex items-center justify-center" data-id="element-130">
      <div className="max-w-[800px] w-full text-center" data-id="element-131">
        <RevealOnScroll data-id="element-132">
          <h2 className="font-serif text-white text-3xl md:text-5xl lg:text-6xl leading-[1.4] md:leading-[1.5]" data-id="element-133">
            <span className="block italic mb-2" data-id="element-134">"As an interior designer,</span>
            <span className="block italic mb-2" data-id="element-135">
              I am the <span className="text-brass" data-id="element-136">bridge</span> that connects
            </span>
            <span className="block italic mb-2 md:ml-12" data-id="element-137">
              your desired environment
            </span>
            <span className="block italic" data-id="element-138">
              to the reality in which it exists."
            </span>
          </h2>

          <div className="w-[60px] h-[1px] bg-brass mx-auto my-12 md:my-16" data-id="element-139"></div>

          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-parchment/60" data-id="element-140">
            — ANNA PATY, PRINCIPAL DESIGNER.
          </p>
        </RevealOnScroll>
      </div>
    </section>;
}